var $ = window.jQuery = require('jquery');
import {
  bus
} from '../../main';
export default {
  name: 'quiz-games',
  components: {},
  props: [],
  data() {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  computed: {

  },
  mounted() {
    $(document).ready(function () {
      $(".hud_circle > .quiz_cont_list_name").on("mouseenter", function () {
        $(this).parents('.hud_circle').addClass("hover_cat");
      });
      $(".hud_circle > .quiz_cont_list_name").on("mouseleave", function () {
        $(this).parents('.hud_circle').removeClass("hover_cat");
      });
    });
  },
  methods: {
    QuizCategoryPopupClose() {
      $(".quizzort_main_wrp").removeClass("popup_active");
      setTimeout(() => {
        bus.$emit('showQuizzortGames', false);
        bus.$emit('hideQuizzortPopupEnabled', false);
        $("body").removeClass("quizzort_popup_active");
      }, 500)
    }
  }
}